export default __webpack_public_path__ + "static/media/Bin.0742b4c9.xlsx";